import React from "react";
import { get } from "lodash";

import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

import testimonialQuotes from "@sendmagic/prismic-nextjs/src/assets/images/quotes1.png";

const QuoteImage = ({ quoteClass }) => (
  <div className={`${quoteClass} col-md-2 col-3`}>
    <Multimedia type="image" src={testimonialQuotes} className="w-100" isNextImage={false} />
  </div>
);

const Testimonial = ({ doc }) => {
  const {
    background_color,
    customer_name,
    customer_company,
    testimonial_text,
    internal_link_id,
    image: { url, alt },
  } = get(doc, "primary", {});
  const backgroundClass = `testimonial-bg-${background_color}`;
  const isCustomerNamePresent = checkContentPresence(customer_name);
  const isCustomerCompanyNamePresent = checkContentPresence(customer_company);
  const noImage = url ? "" : "no-image";
  return (
    <div className={`testimonials-section ${backgroundClass} ${noImage}`}>
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width py-md-5 py-2xl-5 position-relative testimonials-container">
        <QuoteImage quoteClass="testimonial-quotes-start" />
        <QuoteImage quoteClass="testimonial-quotes-end" />
        <div className="row py-md-5 py-2xl-5 py-4 position-relative testimonial-section-row">
          <div className="col-11 col-lg-9 mx-auto testimonial-content-section">
            {url && (
              <div className="testimonial-image mx-auto bg-white rounded-circle overflow-hidden">
                <PrismicImgix
                  className="w-100 rounded-circle"
                  alt={alt}
                  src={url}
                  desktop="170px"
                  mobile="350px"
                  tablet="170px"
                  largeDisplay="300px"
                />
              </div>
            )}
            <div className="testimonial-content-container">
              <div className="text-center text-white py-md-5 py-2xl-5 py-4 testimonial-text-primary">
                {textResolver(testimonial_text)}
              </div>
              {(isCustomerNamePresent || isCustomerCompanyNamePresent) && (
                <div className="text-center text-white testimonial-text-secondary">
                  -{textResolver(customer_name)}
                  {isCustomerNamePresent && isCustomerCompanyNamePresent && ", "}
                  {textResolver(customer_company)}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
